const pad = (value) => String(value).padStart(2, "0");

const formatUtcDateTime = (date) => {
  const d = new Date(date);
  return (
    `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}` +
    `T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(d.getUTCSeconds())}Z`
  );
};

const formatAllDayDate = (date) => {
  const d = new Date(date);
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`;
};

const escapeText = (value) =>
  String(value || "")
    .replace(/\\/g, "\\\\")
    .replace(/\n/g, "\\n")
    .replace(/,/g, "\\,")
    .replace(/;/g, "\\;");

const foldLine = (line) => {
  const limit = 73;
  if (line.length <= limit) return line;
  const parts = [];
  let remaining = line;
  while (remaining.length > limit) {
    parts.push(remaining.slice(0, limit));
    remaining = ` ${remaining.slice(limit)}`;
  }
  parts.push(remaining);
  return parts.join("\r\n");
};

const buildEventBlock = (event, index) => {
  const uid = `${event.uid || `supplyhawk-${Date.now()}-${index}`}@thesupplyhawk.com`;
  const lines = [
    "BEGIN:VEVENT",
    `UID:${escapeText(uid)}`,
    `DTSTAMP:${formatUtcDateTime(new Date())}`,
    `SUMMARY:${escapeText(event.title || "SupplyHawk Event")}`,
  ];

  if (event.allDay) {
    const start = new Date(event.start);
    const endExclusive = new Date(start);
    endExclusive.setDate(endExclusive.getDate() + 1);
    lines.push(`DTSTART;VALUE=DATE:${formatAllDayDate(start)}`);
    lines.push(`DTEND;VALUE=DATE:${formatAllDayDate(endExclusive)}`);
  } else {
    const start = new Date(event.start);
    const end = new Date(event.end || start);
    lines.push(`DTSTART:${formatUtcDateTime(start)}`);
    lines.push(`DTEND:${formatUtcDateTime(end)}`);
  }

  if (event.description) lines.push(`DESCRIPTION:${escapeText(event.description)}`);
  if (event.location) lines.push(`LOCATION:${escapeText(event.location)}`);
  if (event.url) lines.push(`URL:${escapeText(event.url)}`);

  lines.push("END:VEVENT");
  return lines.map(foldLine).join("\r\n");
};

export const downloadOutlookCalendarFile = ({ filename = "supplyhawk-export.ics", events = [] }) => {
  if (!Array.isArray(events) || events.length === 0) return false;

  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//SupplyHawk//Calendar Export//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    ...events.map((event, index) => buildEventBlock(event, index)),
    "END:VCALENDAR",
  ].join("\r\n");

  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return true;
};

export const getWeekRange = (anchorDate = new Date()) => {
  const base = new Date(anchorDate.getFullYear(), anchorDate.getMonth(), anchorDate.getDate());
  const start = new Date(base);
  start.setDate(start.getDate() - start.getDay());
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  return { start, end };
};

export const isDateWithinWeek = (date, weekRange) => {
  if (!date || !weekRange?.start || !weekRange?.end) return false;
  const value = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const start = new Date(weekRange.start.getFullYear(), weekRange.start.getMonth(), weekRange.start.getDate());
  const end = new Date(weekRange.end.getFullYear(), weekRange.end.getMonth(), weekRange.end.getDate());
  return value >= start && value <= end;
};
